<template>
  <el-dialog
    class="dialog-wx-mch-schedule"
    :title="`微信商户定时器管理`"
    :visible.sync="show"
    :close-on-click-modal="false"
    :before-close="closed"
    width="980px"
  >
    <table-view
      class="wechat-merchant-manage"
      :total="total"
      :query-info.sync="queryInfo"
      @reload-table="renderTable">
      <template #header>
        <view-search-form
          keyword-placeholder="商户名"
          :query-info.sync="queryInfo"
          :tool-list="['keyword']"
          :show-clear-btn="false"
          style="display: inline-block;"
          @on-search="renderTable(1)"
        >
          <el-form-item prop="executeFlag" label="启用状态">
            <el-select ref="roleREf" size="small" v-model="queryInfo.executeFlag"
                       clearable
                       style="width: 100px;"
                       @change="renderTable(1)"
            >
              <el-option label="未启用" :value="0" />
              <el-option label="已启用" :value="1" />
            </el-select>
          </el-form-item>
        </view-search-form>
        <div class="header-button">
          <el-button type="primary" size="small" @click="newRow">新增定时器</el-button>
        </div>
      </template>
      <el-form ref="formRef" :model="formData" label-width="0" style="padding-right: 0;">
        <el-table :data="formData.tableData" style="height: 50vh;">
          <el-table-column label="ID" type="index" width="50px" align="center" />
          <el-table-column label="微信商户" min-width="160px">
            <template v-slot="scope">
              <el-form-item
                v-if="scope.row.isEditing"
                :prop="`tableData.${scope.$index}.wxMchId`"
                :rules="rules.wxMchId">
                <el-select ref="roleREf" size="small" v-model="scope.row.wxMchId" placeholder="请选择微信商户"
                           clearable
                           filterable>
                  <el-option v-for="{name,id} in wxMchList" :key="id"
                             :label="name"
                             :value="id" />
                </el-select>
              </el-form-item>
              <span v-else>{{ scope.row.wxMchName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="启用时间" width="220px">
            <template v-slot="scope">
              <el-form-item v-if="scope.row.isEditing" :prop="`tableData.${scope.$index}.startTime`"
                            :rules="rules.startTime">
                <el-date-picker
                  v-model="scope.row.startTime"
                  type="datetime"
                  :picker-options="pickerOptions"
                  align="right"
                  size="small"
                  value-format="yyyy-MM-dd HH:mm:00"
                  format="yyyy-MM-dd HH:mm" />
              </el-form-item>
              <span v-else>{{ scope.row.startTime }}</span>
            </template>
          </el-table-column>
          <el-table-column label="启用状态" width="100px" align="center">
            <template v-slot="{row}">
              <el-tag v-show="!row.isEditing" :type="row.executeFlag?'info':'primary'">
                {{ row.executeFlag ? '已启用' : '待启用' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="备注" width="220px">
            <template v-slot="scope">
              <el-form-item v-if="scope.row.isEditing" :prop="`tableData.${scope.$index}.remarks`">
                <el-input type="textarea" :rows="3" size="small" v-model="scope.row.remarks" maxlength="200" />
              </el-form-item>
              <span v-else>{{ scope.row.remarks }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="160px">
            <template v-slot="scope">
              <template v-if="scope.row.isEditing">
                <el-form-item>
                  <el-button size="small" @click="cancel(scope)">取消</el-button>
                  <el-button v-role="['开发人员']"
                             type="primary" size="small"
                             v-if="scope.row.isEditing" @click="handleSave(scope)">保存
                  </el-button>
                </el-form-item>
              </template>
              <template v-else>
                <template v-if="!isEditing">
                  <el-button v-permission="['wechat:shop:edit']" size="mini"
                             type="danger"
                             @click="del(delWxMchScheduleApi, scope.row.id,`定时器-${scope.row.wxMchName}(${scope.row.startTime})`)">
                    删除
                  </el-button>
                  <el-button v-permission="['wechat:shop:edit']" size="mini"
                             type="primary" plain
                             @click="editRow(scope)">编辑
                  </el-button>
                </template>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </el-form>

    </table-view>
    <template #footer>
      <el-button :disabled="isEditing" @click="closed">关闭</el-button>
    </template>
  </el-dialog>
</template>

<script>
import dialog from '@/vue/mixins/dialog'
import tableView from '@/vue/mixins/table-view'
import {
  delWxMchScheduleApi,
  pageWxMchScheduleApi,
  saveWxMchScheduleApi
} from '@/api/finance-manage/wechat-merchant-manage-api'
import Vue from 'vue'

export default {
  name: 'DialogWxMchSchedule',
  mixins: [dialog, tableView],
  props: {
    wxMchList: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      isEditing: false,
      queryInfo: {
        pageSize: 10
      },
      formData: {
        tableData: []
      },
      rules: {
        wxMchId: { required: true, message: '请选择微信商户', trigger: 'blur' },
        startTime: { required: true, message: '请选择启用时间', trigger: 'blur' }
      },
      pickerOptions: {
        disabledDate: (time) => {
          const timesValue = this.$moment(time).valueOf()
          const _Now = this.$moment().subtract(1, 'days').valueOf()
          return timesValue < _Now
        }
      }
    }
  },
  created() {
    this.renderTable(1)
  },
  methods: {
    delWxMchScheduleApi, // 删除api
    async renderTable(pageNum) {
      try {
        if (pageNum) {
          this.queryInfo.pageNum = pageNum
        }
        this.loading = true
        const { data } = await pageWxMchScheduleApi(this.queryInfo)
        this.formData.tableData = data.list
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    editRow(scope) {
      this.isEditing = true
      scope.row.isEditing = true
      Vue.set(this.formData.tableData, scope.$index, scope.row)
    },
    newRow() {
      if (this.isEditing) {
        this.$message('请先保存已修改的数据，再进行新增操作！')
      } else {
        const _row = {
          executeFlag: '',
          remarks: '',
          wxMchId: '',
          isEditing: true,
          startTime: ''
        }
        this.formData.tableData.unshift(_row)
        this.isEditing = true
      }
    },
    async cancel(scope) {
      scope.row.isEditing = false
      this.isEditing = false
      Vue.set(this.formData.tableData, scope.$index, scope.row)
      await this.renderTable()
    },
    // 设为启用定时器
    handleEnable(event, row) {
      if (row.isEditing) return
      this.$confirm(`是否要启用定时器${row.wxMchName}?`, '启用定时器').then(async () => {
        try {
          await saveWxMchScheduleApi({ ...row, executeFlag: 1 })
          this.$message.success(`定时器${row.name}启用成功！`)
          await this.renderTable()
        } catch (e) {
        }
      }).catch().finally(async () => {
      })
    },
    handleSave(scope) {
      const _now = this.$moment()
      const _startTime = this.$moment(scope.row.startTime)
      const _startTimeDiff = _startTime.diff(_now, 'minutes')
      if (_startTimeDiff < 10) {
        this.$message.error('定时器启用时间不能早于当前时间10分钟内！')
        return
      }
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.$confirm('点击确定保存微信商户定时器。', '保存').then(async () => {
            try {
              await saveWxMchScheduleApi(scope.row)
            } catch (e) {
            }
          }).catch(() => {
            this.cancel(scope)
          }).finally(() => {
            this.renderTable()
            this.isEditing = false
          })
        }
      })
    }
  }
}
</script>

<style lang="scss">
.dialog-wx-mch-schedule {
  .el-dialog__body {
    padding-top: 0;
  }

  .table-view__header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    .header-button {
      padding-top: 4px;
    }
  }
}
</style>
